<template>
	<button class="btn" :disabled="loading">
		<spinner v-if="loading" size="small"/>
		<slot v-else/>
	</button>
</template>

<script>
export default {
	props: [
		'loading',
		'click'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ButtonLoading.vue